/**
 * @generated SignedSource<<f0f1e885283f13dabb155cfc5ec4cffa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type mlStats_viewer$data = {
  readonly id: string;
  readonly missionControlData: {
    readonly id: string;
    readonly companiesWithMLModels: ReadonlyArray<{
      readonly companyId: number | null;
      readonly companyName: string | null;
      readonly lowHighModel: boolean | null;
      readonly lowHighModelLastUpdated: string | null;
      readonly lowHighModelAccuracyTest: number | null;
      readonly lowHighModelAccuracyTrain: number | null;
      readonly lowHighModelRmseTest: number | null;
      readonly overrunPredictorPrecisionTest: number | null;
      readonly overrunPredictorRecallTest: number | null;
      readonly roleModel: boolean | null;
      readonly roleModelLastUpdated: string | null;
      readonly roleModelAccuracyTest: number | null;
      readonly roleModelAccuracyTrain: number | null;
      readonly roleModelTop1AccuracyTest: number | null;
      readonly labelModel: boolean | null;
      readonly labelModelLastUpdated: string | null;
      readonly labelModelAccuracyTest: number | null;
      readonly labelModelAccuracyTrain: number | null;
      readonly labelModelTop1AccuracyTest: number | null;
      readonly labelModelTop3AccuracyTest: number | null;
      readonly assigneeModel: boolean | null;
      readonly assigneeModelLastUpdated: string | null;
      readonly assigneeModelAccuracyTest: number | null;
      readonly assigneeModelAccuracyTrain: number | null;
      readonly assigneeModelTop1AccuracyTest: number | null;
      readonly assigneeModelTop3AccuracyTest: number | null;
    } | null> | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"MissionControlHeader_viewer">;
  readonly " $fragmentType": "mlStats_viewer";
};
export type mlStats_viewer$key = {
  readonly " $data"?: mlStats_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"mlStats_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "mlStats_viewer",
  "selections": [
    (v0/*: any*/),
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MissionControlHeader_viewer"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MissionControlDataType",
      "kind": "LinkedField",
      "name": "missionControlData",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "MissionControlCompanyMLStatsType",
          "kind": "LinkedField",
          "name": "companiesWithMLModels",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "companyId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "companyName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "lowHighModel",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "lowHighModelLastUpdated",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "lowHighModelAccuracyTest",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "lowHighModelAccuracyTrain",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "lowHighModelRmseTest",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "overrunPredictorPrecisionTest",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "overrunPredictorRecallTest",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "roleModel",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "roleModelLastUpdated",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "roleModelAccuracyTest",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "roleModelAccuracyTrain",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "roleModelTop1AccuracyTest",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "labelModel",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "labelModelLastUpdated",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "labelModelAccuracyTest",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "labelModelAccuracyTrain",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "labelModelTop1AccuracyTest",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "labelModelTop3AccuracyTest",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "assigneeModel",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "assigneeModelLastUpdated",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "assigneeModelAccuracyTest",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "assigneeModelAccuracyTrain",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "assigneeModelTop1AccuracyTest",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "assigneeModelTop3AccuracyTest",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "366b637b6599f61185da6c8816576554";

export default node;
